module.exports = new __parcel__URL__("bangladesh-landcover-2001-2020--dataset-cover.c192d85d.jpg").toString();